import { render, staticRenderFns } from "./Schedules.vue?vue&type=template&id=4aaa3f6f&scoped=true"
import script from "./Schedules.vue?vue&type=script&lang=ts"
export * from "./Schedules.vue?vue&type=script&lang=ts"
import style0 from "./Schedules.vue?vue&type=style&index=0&id=4aaa3f6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaa3f6f",
  null
  
)

export default component.exports